// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"common_callToAction__Lw__1","fa-angle-right":"common_fa-angle-right__4bKwF"};